import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import DebtReliefGateWrapper from "@components/layouts/debtReliefGateWrapper";
import { useDomainContext } from "@hooks/useDomainContext";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function PrivacyPolicyHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <DebtReliefGateWrapper backGroundColor="#084dc3">
            <PrivacyPolicy
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </DebtReliefGateWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
